import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../lib/content";
import { MaskLine, SectionLabel, FadeUp } from "./Reveal";

export default function Faq() {
  return (
    <section id="faqs" data-testid="faq-section" className="bg-paper py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionLabel>FAQs</SectionLabel>
          <h2 className="font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1]">
            <MaskLine>Questions,</MaskLine>
            <MaskLine delay={0.1}>answered<span className="text-flame">.</span></MaskLine>
          </h2>
          <p className="mt-6 text-ink/60 text-lg max-w-sm">
            Everything about fees, timings, batches and demo classes. Still curious? Just call us.
          </p>
        </div>

        <div className="lg:col-span-7">
          <FadeUp>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-ink/10"
                >
                  <AccordionTrigger className="text-left font-heading font-semibold text-lg sm:text-xl text-ink hover:text-flame hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink/65 text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
